import { NotificationData, notifications } from '@mantine/notifications';
import classes from './notifications.module.css';
import { NotificationIcon } from './NotificationIcon';

const commonNotificationOptions: Partial<NotificationData> = {
  title: null,
  position: 'bottom-left',
  classNames: classes,
  withCloseButton: false,
};

export function showError(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <NotificationIcon variant="error" />,
    autoClose: 4000,
  });
}

export function showSuccess(message: string) {
  notifications.show({
    ...commonNotificationOptions,
    message: message,
    icon: <NotificationIcon variant="success" />,
    autoClose: 2000,
  });
}
